import { findIndex } from 'lodash-es'
import { cookies } from './cookie'
import { http } from './http'
import { COOKIE_KEYS } from '@/constants'

enum Municipality {
  BeiJin = '110000',
  TianJin = '120000',
  ShangHai = '310000',
  ChongQin = '500000'
}

const municipalityList = [
  Municipality.BeiJin,
  Municipality.ShangHai,
  Municipality.TianJin,
  Municipality.ChongQin
]

export interface CityType {
  cityId: string | number
  cityName: string
}

export const defaultCity: CityType = {
  cityId: '320100',
  cityName: '南京'
}

export function getCityId(cityId: string | number) {
  if (findIndex(municipalityList, o => o == cityId) > -1) {
    cityId = Number(cityId) + 100
  }
  return `${cityId}`
}

async function getCityNameByCityId(cityId: string | number): Promise<string> {
  const response: any = await http.get(
    '//address.cekid.com/addressview/GetNameById',
    {
      params: {
        addressId: cityId
      }
    }
  )
  if (response && response.RetCode * 1 === 0) {
    return (response.Result && response.Result.NAME) || ''
  } else {
    return ''
  }
}

/* 从服务前端使用的city_service获取选择城市 */
export async function getSelectedCity(
  customCity: CityType | null = defaultCity
): Promise<CityType | null> {
  let cityId = ''
  let cityName = ''
  const cityIdCityName = cookies.get(COOKIE_KEYS.CITY_SERVICE)
  if (cityIdCityName) {
    const iNList = cityIdCityName.split('_')
    cityId = iNList[0]
    cityName = decodeURIComponent(iNList[1])
  } else {
    cityId = cookies.get(COOKIE_KEYS.CITYCODE)
    if (cityId) {
      cityName = await getCityNameByCityId(cityId)
    }
  }
  if (cityId && cityName) {
    cityId = getCityId(cityId)
    cityName = cityName.replace('市', '')
    return {
      cityId,
      cityName
    }
  } else {
    return customCity
  }
}

/* 从服务前端使用的city_service获取选择城市id */
export function getSelectedCityId(
  customCityId = defaultCity.cityId
): string | number {
  let cityId = ''
  const cityIdCityName = cookies.get(COOKIE_KEYS.CITY_SERVICE)
  if (cityIdCityName) {
    const iNList = cityIdCityName.split('_')
    cityId = iNList[0]
  } else {
    cityId = cookies.get(COOKIE_KEYS.CITYCODE) || ''
  }
  cityId = getCityId(cityId)
  return cityId || customCityId
}

/* 同步所有选择城市cookie */
export function setSelectedCity(
  citycode: string | number,
  cityName: string
): void {
  cookies.set(COOKIE_KEYS.CITY_SERVICE, `${citycode}_${cityName}`, {
    domain: '.cekid.com'
  })

  cookies.set(COOKIE_KEYS.CITYCODE, `${citycode}`, {
    domain: '.cekid.com'
  })
  cookies.set(COOKIE_KEYS.CITY, `${citycode}_${cityName}`, {
    domain: '.cekid.com'
  })
}
